import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";
import "ag-grid-enterprise/styles/ag-theme-alpine.css";
import "ag-grid-enterprise/styles/ag-grid.css";
import "ag-grid-enterprise/styles/ag-theme-quartz.css";
import { Flex, Modal, Tag } from "antd";
import InviteMember from "app/scenes/Settings/components/InviteMember";
import { Button } from "antd";
import { CopyOutlined, PlusOutlined } from "@ant-design/icons";
import "./App.css";
import { useRecoilState } from "recoil";
import { roleInfo, userInfo } from "app/config/States/users";
import Typography from "app/shared/Typography";
import { colorPicker } from "../../../../../app/utils/color.helper";
import { message ,Popconfirm} from "antd";
import {API_ENDPOINT_SETTING_MEMBER_REMOVE_FROM_WORKSPACE} from "../../../Settings/settings.constants";
import { apiPut ,apiGet} from "app/services/apiServices";
import { API_ENDPOINT_GET_USER_INFO } from "app/scenes/Auth/auth.constants";
import { API_ENDPOINT_USER_LIST } from "../../vendorfollowup.constants";

const UserGrid = (props) => {
  const [rowData, setRowData] = useState([]);
  const [userDetails, setUserDetails] = useRecoilState(userInfo);
  const [removingUser, setRemovingUser] = useState("");//new
  const [tableData, setTableData] = useState([]);//new
  const currentWorkspace = localStorage.getItem("currentWorkspace");

  const [userRole, setUserRole] = useRecoilState(roleInfo);

  const fetchUserData = async () => {
    const authToken = localStorage.getItem("token"); // Retrieve token from localStorage

    if (!authToken) {
      alert("Authentication token not found.");
      return;
    }

    try {
      const response = await axios.get(
        API_ENDPOINT_USER_LIST,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            workspaceid: currentWorkspace,
          },
        }
      );

      if (response.data.status) {
        // const allWorkspaces = [];
        // const filteredData = response.data.data
        //   .filter(
        //     (user) => user.workspace.some((ws) => ws.name === "BHILOSA") // Filter users who have "BHILOSA" in their workspace
        //   )
        //   .map((user) => {
        //     const workspaceCount = user.workspace.length;
        //     const workspaceDisplay =
        //       workspaceCount > 1
        //         ? `${user.workspace[0].name} +${workspaceCount - 1}`
        //         : user.workspace[0]?.name || "";

        //     // Add workspaces to the allWorkspaces array (names only)
        //     user.workspace.forEach((ws) => allWorkspaces.push(ws.name));

        //     return {
        //       id: user.id,
        //       name: user.name,
        //       email: user.email,
        //       password: user.password,
        //       workspaces: workspaceDisplay,
        //     };
        //   });

        setRowData(response.data.data); // Set the filtered data to your state or UI
        // setUserDetails({ workspaces: allWorkspaces });
      } else {
        console.error("Failed to fetch data: ", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching user data: ", error);
    }
  };

  useEffect(() => {
    // Fetch workspace data on mount
    const fetchUserInfo = async () => {
      try {
        const response = await apiGet(API_ENDPOINT_GET_USER_INFO, false);
        if (response.status && response.data?.workspaces) {
          const userWorkspace = response.data.workspaces[0]; // Assuming first workspace
          setUserRole(userWorkspace?.role);
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    fetchUserInfo();
  }, []);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    fetchUserData();
  }, [props.selectedWorkspace]);

  const copyDataToBoard = (text) => {
    navigator?.clipboard?.writeText(text);
    messageApi.open({
      type: "success",
      content: "Copied",
    });
  };
  //new--
  const removeUserFormWorkspace = async (userId) => {
    setRemovingUser(userId);
    const response = await apiPut(
      API_ENDPOINT_SETTING_MEMBER_REMOVE_FROM_WORKSPACE + userId,
      {
        type: props.noHeader ? "SINGLE" : "ALL",
      }
    );

    if (response.status) {
      message.success("User removed from workspace");
      const result = tableData.filter((item) => item.id !== userId);
      setTableData(result); // Update state with filtered data
    } else {
      messageApi.error({
        type: "error",
        content: response.message,
      });
    }
    setRemovingUser("");
  };

  const columnDefs = [
    { headerName: "Name", field: "name", sortable: true },
    { headerName: "Email", field: "email", sortable: true },
    { headerName: "Workspaces", field: "workspaces", sortable: true },
    {
      field: "password",
      headerName: "Temporary Password",
      enableRowGroup: true,
      minWidth: 200,
      cellRenderer: (params) => {
        return params?.data?.password ? (
          <div
            style={{
              display: "flex",
              height: "100%",
              width: "100%",
              alignItems: "center",
            }}
          >
            <Tag
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => copyDataToBoard(params?.data?.password)}
            >
              <CopyOutlined />
              <Typography
                variant="xs"
                style={{
                  color: colorPicker("neutral.700"),
                  marginLeft: 4,
                }}
              >
                Copy Password
              </Typography>
            </Tag>
          </div>
        ) : null;
      },
    },
    ...(userRole === "ADMIN"
      ? [
          {
            field: "action",
            headerName: "Action",
            cellRenderer: (params) => {
              return (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <Popconfirm
                    title="Remove user from workspace"
                    description="Are you sure want to remove?"
                    onConfirm={() =>
                      removeUserFormWorkspace(params.data?.id)
                    }
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      size="small"
                      danger
                      loading={removingUser === params.data?.id}
                    >
                      Remove
                    </Button>
                  </Popconfirm>
                </div>
              );
            },
          },
        ]
      : []), 
    //     {
    //         headerName: "Action",
    //         cellRenderer: (params) => {
    //           const id = params.data.id; // Access the data's ID field
    //           return (
    //             <div style={{ display: "flex", gap: "10px", }}>
    //             <button
    //               onClick={() => handleEdit(id)}
    //               style={{
    //                 display: "flex",
    //                 alignItems: "center",
    //                 justifyContent: "center",
    //                 gap: "5px",
    //                 padding: "10px 10px",
    //                 backgroundColor: "white",
    //                 color: "#007B7C",
    //                 border: "1px solid #007B7C",
    //                 borderRadius: "5px",
    //                 cursor: "pointer",
    //                 fontSize: "10px",
    //                 height:'30px',
    //                 marginTop:'5px'
    //               }}
    //             >
    //               Edit
    //               <span><svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
    //   <path d="M6.69043 5.83343H5.8571C5.41507 5.83343 4.99115 6.00903 4.67858 6.32159C4.36602 6.63415 4.19043 7.05807 4.19043 7.5001V15.0001C4.19043 15.4421 4.36602 15.8661 4.67858 16.1786C4.99115 16.4912 5.41507 16.6668 5.8571 16.6668H13.3571C13.7991 16.6668 14.223 16.4912 14.5356 16.1786C14.8482 15.8661 15.0238 15.4421 15.0238 15.0001V14.1668M14.1904 4.16677L16.6904 6.66677M17.8446 5.48759C18.1728 5.15938 18.3572 4.71424 18.3572 4.25009C18.3572 3.78594 18.1728 3.34079 17.8446 3.01259C17.5164 2.68438 17.0712 2.5 16.6071 2.5C16.1429 2.5 15.6978 2.68438 15.3696 3.01259L8.3571 10.0001V12.5001H10.8571L17.8446 5.48759Z" stroke="#0A8394" stroke-linecap="round" stroke-linejoin="round"/>
    // </svg></span>
    //             </button>
    //             <button
    //               onClick={() => handleDelete(id)}
    //               style={{
    //                 display: "flex",
    //                 alignItems: "center",
    //                 justifyContent: "center",
    //                 gap: "5px",
    //                 padding: "10px 20px",
    //                 backgroundColor: "#007B7C",
    //                 color: "white",
    //                 border: "none",
    //                 height:'30px',
    //                 borderRadius: "5px",
    //                 cursor: "pointer",
    //                 fontSize: "10px",
    //                 marginTop:'5px'
    //               }}
    //             >

    //               Delete
    //               <span><svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
    //   <path d="M4.19043 5.83333H17.5238M9.19043 9.16667V14.1667M12.5238 9.16667V14.1667M5.02376 5.83333L5.8571 15.8333C5.8571 16.2754 6.03269 16.6993 6.34525 17.0118C6.65781 17.3244 7.08174 17.5 7.52376 17.5H14.1904C14.6325 17.5 15.0564 17.3244 15.3689 17.0118C15.6815 16.6993 15.8571 16.2754 15.8571 15.8333L16.6904 5.83333M8.3571 5.83333V3.33333C8.3571 3.11232 8.44489 2.90036 8.60117 2.74408C8.75745 2.5878 8.96942 2.5 9.19043 2.5H12.5238C12.7448 2.5 12.9567 2.5878 13.113 2.74408C13.2693 2.90036 13.3571 3.11232 13.3571 3.33333V5.83333" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    // </svg></span>
    //             </button>
    //           </div>
    //           );
    //         },
    //       }
  ];

  const defaultColDef = {
    filter: true,
    floatingFilter: true,
    sortable: true,
    resizable: true,
    enableRowGroup: true,
    floatingFilter: true,
    flex: 1,
    filter: "agTextColumnFilter",
  };

  const gridOptions = {
    animateRows: true,
    sideBar: {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          minWidth: 225,
          maxWidth: 225,
          width: 225,
        },
        {
          id: "filters",
          labelDefault: "Filters",
          labelKey: "filters",
          iconKey: "filter",
          toolPanel: "agFiltersToolPanel",
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
        // {
        //   id: "pdf viewer",
        //   labelDefault: "View",
        //   labelKey: "view",
        //   iconKey: "pdfIcon",
        //   toolPanel: "agFiltersToolPanel",
        //   minWidth: 180,
        //   maxWidth: 400,
        //   width: 250,
        // },
      ],
      position: "right",
    },

    icons: {
      pdfIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10.377 11.2188L10.3828 11.1914C10.4961 10.7246 10.6387 10.1426 10.5273 9.61523C10.4531 9.19922 10.1465 9.03711 9.88477 9.02539C9.57617 9.01172 9.30078 9.1875 9.23242 9.44336C9.10352 9.91211 9.21875 10.5527 9.42969 11.3691C9.16406 12.002 8.74023 12.9219 8.42969 13.4688C7.85156 13.7676 7.07617 14.2285 6.96094 14.8105C6.9375 14.918 6.96484 15.0547 7.0293 15.1777C7.10156 15.3145 7.2168 15.4199 7.35156 15.4707C7.41016 15.4922 7.48047 15.5098 7.5625 15.5098C7.90625 15.5098 8.46289 15.2324 9.20508 13.959C9.31836 13.9219 9.43555 13.8828 9.54883 13.8438C10.0801 13.6641 10.6309 13.4766 11.1289 13.3926C11.6797 13.6875 12.3066 13.877 12.7324 13.877C13.1543 13.877 13.3203 13.627 13.3828 13.4766C13.4922 13.2129 13.4395 12.8809 13.2617 12.7031C13.0039 12.4492 12.377 12.3828 11.4004 12.5039C10.9199 12.2109 10.6055 11.8125 10.377 11.2188ZM8.23438 14.1855C7.96289 14.5801 7.75781 14.7773 7.64648 14.8633C7.77734 14.623 8.0332 14.3691 8.23438 14.1855ZM9.94531 9.58594C10.0469 9.75977 10.0332 10.2852 9.95508 10.5508C9.85938 10.1621 9.8457 9.61133 9.90234 9.54688C9.91797 9.54883 9.93164 9.56055 9.94531 9.58594ZM9.91406 11.9395C10.123 12.3008 10.3867 12.6113 10.6777 12.8418C10.2559 12.9375 9.87109 13.0957 9.52734 13.2363C9.44531 13.2695 9.36523 13.3027 9.28711 13.334C9.54688 12.8633 9.76367 12.3301 9.91406 11.9395ZM12.9531 13.2188C12.9551 13.2227 12.957 13.2285 12.9453 13.2363H12.9414L12.9375 13.2422C12.9219 13.252 12.7617 13.3457 12.0723 13.0742C12.8652 13.0371 12.9512 13.2168 12.9531 13.2188ZM16.6914 5.63672L12.4883 1.43359C12.3711 1.31641 12.2129 1.25 12.0469 1.25H3.75C3.4043 1.25 3.125 1.5293 3.125 1.875V18.125C3.125 18.4707 3.4043 18.75 3.75 18.75H16.25C16.5957 18.75 16.875 18.4707 16.875 18.125V6.08008C16.875 5.91406 16.8086 5.75391 16.6914 5.63672ZM15.4336 6.36719H11.7578V2.69141L15.4336 6.36719ZM15.4688 17.3438H4.53125V2.65625H10.4297V6.875C10.4297 7.09256 10.5161 7.30121 10.67 7.45505C10.8238 7.60889 11.0324 7.69531 11.25 7.69531H15.4688V17.3438Z" fill="black" fill-opacity="0.45"/>
      </svg>`,
    },
  };

  const [showModal, setShowModal] = useState(false);

  const handleMemberShipSuccess = () => {
    // Logic when member is successfully added;
    setShowModal(false); // Close the modal
  };

  return (
    <div
      className="ag-theme-alpine"
      style={{ height: "85vh", width: "100%", position: "relative", zIndex: "0" }}
    >
      <AgGridReact
        rowData={rowData}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        gridOptions={gridOptions}
        rowGroupPanelShow="always"
        rowSelection="multiple"
        // groupDefaultExpanded={-1}

        enableSorting={true}
        enableFilter={true}
      />
    </div>
  );
};

export default UserGrid;
